"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    var titleElement = document.createElement("h2");
    titleElement.classList.add("title");
    titleElement.textContent = title;
    var descriptionElement = document.createElement("p");
    descriptionElement.textContent = description;
    notification.append(titleElement, descriptionElement);
    document.body.append(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.088d24e6.js.map
